module.exports = __webpack_public_path__ + "media/images/link-d1efc892d3487ddf4319df2ba44b6cb3.svg";